import React, { useEffect } from "react";
import { Box, Container, Typography, Grid, Link } from "@mui/material";
import ColorData from "../CstmTheme/ColorData";
import ImgPath from "../../Constants/Imgs";
import { currentYear } from "Utils/Common";

const Footer = () => {
  // Inject Zoho script only once when component mounts
  // useEffect(() => {
  //   // Define the global Zoho object before script loads
  //   (window as any).$zoho = (window as any).$zoho || {};
  //   (window as any).$zoho.salesiq = (window as any).$zoho.salesiq || {
  //     ready: function () {},
  //   };

  //   // Create script tag
  //   const script = document.createElement("script");
  //   script.id = "zsiqscript";
  //   script.src =
  //     "https://salesiq.zohopublic.in/widget?wc=siqd7707a9039bd6effac697257b5da4841f1a7b648d2deaf53c922eb053d319179";
  //   script.defer = true;
  //   // Append it just before the closing </body>
  //   document.body.appendChild(script);
  //   const interval = setInterval(() => {
  //     const zohoWidget = document.getElementById("zsiq_float"); // Zoho bubble id
  //     if (zohoWidget) {
  //       zohoWidget.style.bottom = "70px"; // move higher (default is ~20-30px)
  //       zohoWidget.style.right = "10px";  // keep aligned with your WhatsApp icon
  //       clearInterval(interval);
  //     }
  //   }, 500); // check every 0.5s until widget exists
  
  //   return () => clearInterval(interval);
  // }, []);
  const links = [
    { label: "About Us", href: "/about-us.html" },
    { label: "Career", href: "/career.html" },
    { label: "Blog", href: "#" },
    { label: "Rules & Policies", href: "#" },
    { label: "FAQ", href: "#" },
  ];

  const footerLinks = [
    { label: "Help & Support", href: "/help-center.html" },
    { label: "Partner with Us", href: "#" },
    { label: "Terms & Conditions", href: "#" },
    { label: "Privacy Policy", href: "#" },
    { label: "Download the App", href: "#" },
];
  return (
    <Box
      component="footer"
      className="footer footer-main"
      sx={{
        backgroundColor: ColorData.primary.main,
        color: ColorData.text.secondary,
        pt: 6,
        pb: 1,
      }}
    >
      <Container disableGutters>
        <Grid container spacing={4} sx={{ px: 0, mx: 0 }}>
          {/* Left Side */}
          <Grid
          size={{xs: 12, sm: 12, md: 6}}
            className="col-left"
            sx={{
              px: 0,
              mx: 0,
              width: { md: "50%" }, // enforce 50% on md+
              borderRight: { md: `1px solid ${ColorData.primary.strokeColor}` },
            }}
          >
            <Box>
              <Box
                component="a"
                href="#"
                className="logo-link"
                sx={{ display: "block", mb: 3 }}
              >
                <Box
                  component="img"
                  // backgroundColor={ColorData.background.default}
                  src={"https://nolegalpaisa.com/assets/images/new_logo.webp"}
                  alt="Logo"
                  className="footer-logo"
                  sx={{ 
                    width: { xs: "200px", sm: "250px", md: "300px" },
                    height: { xs: "80px", sm: "100px", md: "120px" },
                    objectFit: "contain",
                    filter: "drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.3))",
                    transition: "transform 0.2s ease-in-out",
                    "&:hover": {
                      transform: "scale(1.05)",
                    },
                  }}
                />
              </Box>
              <Grid
                container
                columnSpacing={28}
                mt={2}
                className="left-link-wrap"
                sx={{
                  borderTop: {
                    md: `1px solid ${ColorData.primary.strokeColor}`,
                  },
                  pt: 4,
                  pb: { xs: 2, md: 3 },
                }}
              >
                <Grid size={{xs: 6}} className="quick-link-wrap">
                  <Typography
                    className="footer-heading"
                    sx={{
                      mb: 2,
                      color: ColorData.text.secondary,
                      fontSize: "20px",
                    }}
                  >
                    Quick Links
                  </Typography>
                  <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                    {links.map((item, index) => (
                      <li
                        key={index}
                        style={{ marginBottom: index < 4 ? 6 : 0 }}
                      >
                        <Link
                          href={item.href}
                          color={ColorData.text.secondary}
                          underline="none"
                        >
                          {item.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </Grid>
                <Grid size={{xs: 6}} className="legal-info-wrap">
                  <Typography
                    // variant="h6"
                    className="footer-heading"
                    sx={{
                      mb: 2,
                      color: ColorData.text.secondary,
                      fontSize: "20px",
                    }}
                  >
                    Legal Information
                  </Typography>
                  <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                    {footerLinks.map((item, index) => (
                      <li
                        key={index}
                        style={{ marginBottom: index < 4 ? 6 : 0 }}
                      >
                        <Link
                          href={item.href}
                          color={ColorData.text.secondary}
                          underline="none"
                        >
                          {item.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </Grid>
              </Grid>
            </Box>
          </Grid>

          {/* Right Side */}
          <Grid size={{xs: 12}} className="col-right">
            <Box
              className="right-address-contact-wrap"
              sx={{
                mt: 4,
                textAlign: { xs: "center", sm: "left" },
                ml: { xs: 0, sm: "10%", md: "20%" },
              }}
            >
              <Box className="address-wrap" mb={5}>
                <Typography
                  className="footer-heading"
                  sx={{
                    mb: 2,
                    color: ColorData.text.secondary,
                    fontSize: "20px",
                  }}
                >
                  Address
                </Typography>
                <Typography variant="body2" color={ColorData.text.secondary}>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry.
                </Typography>
              </Box>
              <Box className="contact-wrap" mb={5}>
                <Typography
                  className="footer-heading"
                  sx={{ mb: 2, fontSize: "20px" }}
                  color={ColorData.text.secondary}
                >
                  Contact Details
                </Typography>
                <Typography color={ColorData.text.secondary} variant="body2">
                  Email:{" "}
                  <Link href="mailto:info@example.com" color="inherit">
                    info@example.com
                  </Link>
                </Typography>
                <Typography variant="body2" color={ColorData.text.secondary}>
                  Phone:{" "}
                  <Link href="tel:+1234567890" color={ColorData.text.secondary}>
                    +123 456 7890
                  </Link>
                </Typography>
              </Box>

              <Box
                className="right-social-wrap"
                sx={{
                  borderTop: {
                    md: `1px solid ${ColorData.primary.strokeColor}`,
                  },

                  pt: 4,
                  // mb: 4,
                }}
              >
                <Typography
                  className="footer-heading"
                  sx={{ mb: 2, fontSize: "20px" }} // fix typo q0px -> 20px
                  color={ColorData.text.secondary}
                >
                  Social Media
                </Typography>

                <Box
                  className="social-icons"
                  display="flex"
                  alignItems="center"
                  justifyContent={{ xs: "center", sm: "flex-start" }}
                  gap={2}
                >
                  <Link href="#">
                    <Box
                      component="img"
                      src={ImgPath.FBIcon}
                      alt="Facebook"
                      className="social-img"
                      sx={{ width: 30, height: 30 }}
                    />
                  </Link>
                  <Link href="#">
                    <Box
                      component="img"
                      src={ImgPath.InstaIcon}
                      alt="Instagram"
                      className="social-img"
                      sx={{ width: 30, height: 30 }}
                    />
                  </Link>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>

        {/* Footer Bottom */}
        <Box
          className="footer-bottom"
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          flexDirection={{ xs: "column", sm: "row" }}
          mt={5}
          pt={2}
          sx={{ borderTop: `1px solid ${ColorData.primary.strokeColor}` }}
        >
          <Typography variant="body2" color={ColorData.text.secondary}>
            ©{currentYear} NoLegalPaisa. All Right Reserved.
          </Typography>
          <Link href="#" underline="none" color={ColorData.text.secondary}>
            Privacy Policy
          </Link>
        </Box>
      </Container>

      {/* WhatsApp Floating Icon */}
      <Box
        component="a"
        href="https://wa.me/919326024128"
        target="_blank"
        rel="noopener"
        className="whatsapp-float"
        sx={{
          position: "fixed",
          bottom: 10,
          right: 10,
          width: 60,
          height: 60,
          zIndex: 1000,
          cursor: "pointer",
          background:
            "linear-gradient(90deg, rgb(18, 198, 101) 0.85%, rgb(0, 148, 70) 100%)",
          borderRadius: "50%",
          p: 1.5,
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
          transition: "transform 0.2s ease-in-out",
        }}
      >
        <Box
          component="img"
          src={ImgPath.WhatsAppIcon}
          alt="Chat on WhatsApp"
          sx={{ width: "100%", height: "100%", objectFit: "contain" }}
        />
      </Box>
    </Box>
  );
};

export default Footer;
